import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from "@shared/services/auth.service";
import { map, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class RoleGuard implements CanActivate {

    constructor(
        private authService: AuthService,
        private router: Router
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot
    ): Observable<boolean> {
        const roles = next.data?.['roles'] as Array<string>;
        return this.checkRoleAccess(roles).pipe(
            take(1),
            map(hasAccess => {
                if (hasAccess) {
                    return true;
                } else {
                    this.router.navigate(['/revenue']);
                    return false;
                }
            })
        );
    }

    checkRoleAccess(roles: any[] | undefined): Observable<boolean> {
        return this.authService.checkRole(roles);
    }
}
